import { YearHeader } from "components";
import { FC } from "react";

type Props = {};

const CancelledOffers: FC<Props> = () => {
  return (
    <main className="flex-1 flex flex-col overflow-hidden bg-background-500">
      <YearHeader />
      {/* Content goes here */}
      <div className="flex flex-1 overflow-y-auto">
        <div className="flex-1 mx-auto min-w-0  py-4 sm:py-6 overflow-hidden overflow-y-auto light flex"></div>
      </div>
    </main>
  );
};

export default CancelledOffers;
